/*       */

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import { RouterMatchPropTypeBuilder } from 'app/utils/propTypes/common';
import PrintPreview from 'app/containers/Entities/Print/PrintPreview';
/**
 * Defines the routes for the Relation Definitions
 */
class PrintRoutes extends PureComponent {
    static propTypes = {
        match: RouterMatchPropTypeBuilder({ id: PropTypes.string }),
        userProfile: PropTypes.object,
    };

    /**
     * @override
     * Always make sure you use PageTemplate as PageContainer
     */
    render() {
        const { match } = this.props;
        return (
            <Fragment>
                <Switch>
                    <Route path={`${match.url}/:templateId/:entityType/:id`} component={PrintPreview} />
                    <Route path={`${match.url}/:templateId`} component={PrintPreview} />
                </Switch>
            </Fragment>
        );
    }
}

export default connect(state => ({
    userProfile: state.user.profile,
}))(PrintRoutes);
